<template>
  <v-chip class="mr-2" :to="linkTo" pill>
    {{ name }}
    <template #append>
      <v-avatar v-if="icon != ''" size="28" class="chip-avatar">
        <img :src="icon" :alt="name" />
      </v-avatar>
      <v-avatar v-else size="28" class="chip-avatar">
        <LetterAvatar :name="short" :size="24" :rounded="true" />
      </v-avatar>
    </template>
  </v-chip>
</template>
<script>
import LetterAvatar from "../ui/LetterAvatar.vue";
export default {
  name: "AccountChip",
  components: { LetterAvatar },
  props: ["icon", "name", "short", "id"],
  computed: {
    linkTo() {
      return `/accounts/${this.id}`;
    },
  },
};
</script>
<style scoped>
.chip-avatar {
  margin-left: 8px;
  margin-right: -4px;
  top: 2px;
  position: relative;
}
</style>
